'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssignedAgentId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAssignedAgentId = exports.getAssignedAgentId = (0, _getIn2.default)(['assignedAgent', 'agentId']);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/assignment-v2-message-metadata/operators/assignmentV2MessageMetadataGetters.js
// module id = 869
// module chunks = 2 3